// GET /api/cases/:id/signals - what the matter's own papers say is wrong
// with it, computed by the server on every read.

import type { CaseSignal, CaseSignalsResponse } from "@duralex/shared";
import { getAuthHeaders } from "./auth";

export type { CaseSignal };

export async function fetchCaseSignals(caseId: string): Promise<CaseSignal[]> {
  const res = await fetch(`/api/cases/${encodeURIComponent(caseId)}/signals`, {
    headers: { ...getAuthHeaders() },
    credentials: "same-origin",
  });
  if (!res.ok) throw new Error(`GET /api/cases/:id/signals failed: ${res.status}`);
  const body = (await res.json()) as Partial<CaseSignalsResponse>;
  return body.signals ?? [];
}
